import { useWorkspaces } from "@/hooks/useWorkspaces";
import { CategoryTreeService } from "@/services/categoryTree/categoryTree.service";

export function useLandingPaths() {
  const { sessionCurrentWorkspaceId } = useWorkspaces();

  const { data, error, isLoading, mutate } = CategoryTreeService.getLandingPathsByWorkspaceId(
    sessionCurrentWorkspaceId,
  );

  return {
    landingPaths: data,
    error,
    isLoading,
    mutate,
  };
}
